export default __webpack_public_path__ + "static/media/gallery_01.3a575de5.jpg";